import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class OverlayService {

    public overlayData = new BehaviorSubject(null);
    public activityConfirm = new BehaviorSubject(null);

}


// WEBPACK FOOTER //
// ./src/app/services/overlay.service.ts